<template>
    <div class="w-100">
        <!-- Page title -->
        <div class="row align-items-center mt-1 mb-3">
            <div class="col-9">
                <h2 class="page-title">
                    {{ pageTitle }}
                </h2>
            </div>
            <!-- Progress bar -->
            <div v-if="progressBar == true && maxStep > 1" class="col-3 ms-auto d-print-none d-flex align-items-center" id="progressBar">
                <span class="small me-3 w-50 text-end">{{ percentageComplete }}% Complete</span>
                <b-progress class="w-50" :value="currentStep" :max="maxStep" animated></b-progress>
            </div>
        </div>

        <!-- Alert box -->
        <div v-if="this.v$.step[this.currentStep - 1].$error" class="alert alert-danger alert-dismissible" role="alert">
            <div class="d-flex">
                <div>
                    <!-- Download SVG icon from http://tabler-icons.io/i/alert-circle -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon alert-icon"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                        <path d="M12 8v4"></path>
                        <path d="M12 16h.01"></path>
                    </svg>
                </div>
                <div>
                    <span v-if="v$.$errors.length > 1"> Sorry, there are ({{ this.v$.step[this.currentStep - 1].$errors.length }}) errors found please correct the errors to proceed.</span>
                    <span v-if="v$.$errors.length <= 1"> Sorry, there's ({{ this.v$.step[this.currentStep - 1].$errors.length }}) error found please correct the error to proceed.</span>
                </div>
            </div>
            <a class="btn-close" data-bs-dismiss="alert" aria-label="close"></a>
        </div>

        <form id="create-room" action="rooms/store" class="add-record">
            <div class="card" v-if="currentStep == 1" title="Room Details">
                <div class="card-header">
                    <h3 class="card-title">Room Details</h3>
                </div>
                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Status</div>
                                <label v-for="option in statusOptions" class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" :value="option" v-model="step[0].status" name="status" />
                                    <span class="form-check-label">{{ option }}</span>
                                </label>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[0].status.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Name</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="name"
                                    placeholder="Enter room name"
                                    v-model="step[0].name"
                                    :class="{
                                        'is-invalid': v$.step[0].name.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[0].name.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Description</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="description"
                                    placeholder="Enter room description"
                                    v-model="step[0].description"
                                    :class="{
                                        'is-invalid': v$.step[0].description.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[0].description.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-10 col-md-8 col-xl-6"></div>
                    </div>
                </div>

                <div class="card-footer">
                    <p class="m-0 text-muted">
                    </p>               
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickNext" class="ml-5 btn btn-primary" id="submit-btn">Finish</a>
                    </p>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import {alpha, alphaNum, email, integer, required, requiredIf, minLength, maxLength, minValue, maxValue} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";

// Custom Validators
const inArray = (array) => (value) => array.includes(value);
const isTextWithSpace = (value) => value.match("^[a-zA-Z0-9_ ]*$");

export default {
    name: "roomCreateComponent",
    props: ["progressBar", "pageTitle", "userId", "areaId", "room", "operation"], // vue can read kebab props as camel cased vars    

    setup() {
        return {v$: useVuelidate()};
    },
    data() {    
        // If editing, assign room object to a variable
        if (this.operation == 'update') {
            var roomObject = JSON.parse(this.room);
            var endpointToUse = location.protocol + "//" + window.location.host + "/api/rooms/" + roomObject.id + "/" + '6m8geptupkijwghd7xkya6wbjkrqo1wwpuuhmzzuuqhqhovy2mclfumdkccg';
        }
        else if (this.operation == 'store') {
            var roomObject = {};
            var endpointToUse = location.protocol + "//" + window.location.host + "/api/rooms/" + '6m8geptupkijwghd7xkya6wbjkrqo1wwpuuhmzzuuqhqhovy2mclfumdkccg';  // TODO: figure out why this.api_token returns undefined  
        }
        

        return {
            currentStep: 1,
            maxStep: 1,
            percentageComplete: 0,
            errors: 0,
            statusOptions: ["Active", "Inactive"], 
            endpoint: endpointToUse,
            step: [
                {
                    // Step 1 - set default value if any
                    name: (roomObject != null) ? roomObject.name : "",
                    description: (roomObject != null) ? roomObject.description : "",
                    status: (roomObject != null) ? roomObject.status : "",      
                },
            ],
            api_token: process.env.MIX_API_KEY,
        };
    },
    validations() {
        const textType = {
            required,
            isTextWithSpace,
            minLength: minLength(3),
            maxLength: maxLength(191),
            $lazy: true,
            $autoDirty: true,
        };
        const longTextType = {
            required,
            isTextWithSpace,
            minLength: minLength(3),
            maxLength: maxLength(1000),
            $lazy: true,
            $autoDirty: true,
        };


        return {
            step: [
                {
                    // Step 1
                    name: textType,
                    description: longTextType,
                    status: {
                        required,
                        inOptions: inArray(this.statusOptions),
                        $lazy: true,
                        $autoDirty: true,
                    }
                },
            ],
        };
    },

    computed: {
        

    },

    methods: {
        onClickNext: function () { 
         
            // Validate fields on current step
            this.v$.step[this.currentStep - 1].$touch();

            // if there are no errors in the current step
            if (!this.v$.step[this.currentStep - 1].$error) {
                if (this.currentStep < this.maxStep) {
                    // Proceed to next step
                    this.currentStep++;

                } else if (this.currentStep == this.maxStep) {

                    // Initialize alerts and toast notifications for displaying message  
                    const toastError = Swal.mixin({          
                            toast: true,                
                            position: 'top-end', 
                            showConfirmButton: true, 
                        });  
                    const alertSuccess = Swal.mixin({                          
                            position: 'center', 
                            showConfirmButton: true, 
                            timer: 3000,
                            timerProgressBar: true,
                        });  
                                    
           
                    
                    // Show button spinner
                    document.getElementById('submit-btn').innerHTML  = '<i class="fa fa-circle-notch fa-spin"></i>';
                    document.getElementById('submit-btn').disabled  = true;                   

                    // Loop through all fields
                    const formData = {};
                    for(let i=0; i < this.maxStep; i++){
                        for ( const [key,value] of Object.entries( this.step[i] ) ) {
                            // formData.append(key, value);
                            formData[key] = value;
                        }
                    }

                    // Add userID and areaID
                    formData['userID'] = this.userId;
                    formData['areaID'] = this.areaId; 
                    
                    if (this.operation == 'store') {
                        this.createRoom(formData, toastError, alertSuccess);
                    }
                    else if(this.operation == 'update') {
                        this.updateRoom(formData, toastError, alertSuccess);
                    }

                }
                this.percentageComplete = Math.round((this.currentStep / this.maxStep) * 100);
            }
        },

        createRoom: function(formData, toastError, alertSuccess) {
            // Call the store endpoint    
            axios.post(this.endpoint, formData)
                .then((response) => {
                    if(response.data.error == 403){                                
                        console.log('Bad Request');
                        console.log(response.data);
                        
                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({ 
                            type: 'warning', 
                            title: 'The input fields are malformed and cant be processed.' 
                        }); 
                    } else {
                        if(response.data.id == null){
                            console.log('Validation Error');
                            console.log(response.data);
                            
                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the room object
                            toastError.fire({ 
                                type: 'warning', 
                                title: 'There are validation errors found on the form.'
                            }); 
                            
                        }
                        else{
                            console.log("Success");
                            console.log(response.data);

                                // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the room object was added to the DB. Thi
                            this.formSuccess = true                          
                            alertSuccess.fire({
                                title: "Success!",
                                text: "The room has been added.",
                                icon: "success",                           
                            }).then(function(){
                                window.location = "/areas/"+formData['areaID'];
                            }); 
                        }
                    }                                        
                    
                })
                .catch((err) => {                            
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({ type: 'error', title: 'Sorry, request failed to submit.' }); // this error occurs when endpoint is wrong
                })
        },
        
        updateRoom: function(formData, toastError, alertSuccess) {        
            console.log(this.endpoint);
            // Call the update endpoint
            axios.put(this.endpoint, formData)
                .then((response) => {
                    if(response.data.error == 403){                                
                        console.log('Bad Request');
                        console.log(response.data);
                        
                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({ 
                            type: 'warning', 
                            title: 'The input fields are malformed and cant be processed.' 
                        }); 
                    } else {
                        if(response.data.id == null){
                            console.log('Validation Error');
                            console.log(response.data);
                            
                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the room object
                            toastError.fire({ 
                                type: 'warning', 
                                title: 'There are validation errors found on the form.'
                            }); 
                            
                        }
                        else{
                            console.log("Success");
                            console.log(response.data);

                                // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the room object was added to the DB. Thi
                            this.formSuccess = true                          
                            alertSuccess.fire({
                                title: "Success!",
                                text: "The room has been updated.",
                                icon: "success",                           
                            }).then(function(){
                                window.location = "/areas/"+formData['areaID'];
                            }); 
                        }
                    }                                        
                    
                })
                .catch((err) => {                            
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({ type: 'error', title: 'Sorry, request failed to submit.' }); // this error occurs when endpoint is wrong
                })
        },

    },
};
</script>
